import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { store } from '@/store';
import { PurchaseCtaEnum } from '@/services/product.service';
import TrackingService from '@/core/tracking.service';
import PriceInformationB2B from '@/ui/views/product-details/PriceInformationB2B.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SparePartItem',
  props: {
    product: null
  },
  setup(__props: any) {

const props = __props as {product: SparePartVariantBaseViewObject}



const findRetailersUrl = computed<string>(() => store.getters['app/findRetailersUrl']);
const theme = computed<ColorTheme>(() => store.getters['app/theme']);
const textColor = computed<OpacityFunction>(() => store.getters['app/textColor']);
const gaTrackingGoal = computed<string>(() => store.getters['catalog/gaTrackingGoal']);

const defaultProductImage = computed(() => {
    if (props.product.images.length > 0) {
        const defaultImage = props.product.images.find(img => img.isDefault);
        return defaultImage ? defaultImage.url : props.product.images[0].url;
    }
    return null;
});

const showAddToBasketButton = computed(() => {
    return props.product.purchaseCta === (PurchaseCtaEnum.AddToBasket as any);
});

const showFindDealerButton = computed(() => {
    return props.product.purchaseCta === (PurchaseCtaEnum.FindDealer as any);
});

const showGetQuoteButton = computed(() => {
    return props.product.purchaseCta === (PurchaseCtaEnum.GetQuote as any);
});

const showB2BBuyButton = computed(() => {
    return props.product.purchaseCta === (PurchaseCtaEnum.AddToBasketB2B as any) || props.product.purchaseCta === (PurchaseCtaEnum.ShowPricingB2B as any);
});

function findRetailerButtonClicked() {
    TrackingService.event('Ecommerce', gaTrackingGoal.value, 'Spare part - find dealer');
}

const isPriceInformationDisabled = computed(() => {
    const isAddToBasket = props.product.purchaseCta === (PurchaseCtaEnum.AddToBasketB2B as any);
    const isShowPricing = props.product.purchaseCta === (PurchaseCtaEnum.ShowPricingB2B as any);

    if (!isAddToBasket && !isShowPricing) { return true; }

    return false;
});


return { __sfc: true,props, findRetailersUrl, theme, textColor, gaTrackingGoal, defaultProductImage, showAddToBasketButton, showFindDealerButton, showGetQuoteButton, showB2BBuyButton, findRetailerButtonClicked, isPriceInformationDisabled, PriceInformationB2B }
}

})